import script from "./updatePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./updatePassword.vue?vue&type=script&setup=true&lang=js"

import "./updatePassword.vue?vue&type=style&index=0&id=43a5bb12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a5bb12"]])

export default __exports__